import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type Version from "./Version";

@Model()
class DistributionList extends ApplicationRecord {
  static jsonapiType = "distribution_lists";

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() recipients: string[];

  @Attr({ persist: false }) referenceEmail: string;

  @Attr() restricted: boolean;

  @HasMany() versions: Version;
}

export default DistributionList;
